<template>
  <aside :show.sync="show" placement="right" header="新增路线" :width="400">
    <form class="form-horizontal">
      <div class="form-group">
        <label for="name" class="col-xs-3 control-label">路线简称</label>
        <div class="col-xs-9">
          <input type="text" id="name" v-model="route.abbreviation" class="form-control">
        </div>
      </div>

      <div class="form-group">
        <label for="name" class="col-xs-3 control-label">路线标题</label>
        <div class="col-xs-9">
          <input type="text" id="name" v-model="route.heading" class="form-control">
        </div>
      </div>

      <div class="form-group">
        <label for="f3" class="col-xs-3 control-label">分类</label>
        <div class="col-xs-9">
          <select class="form-control" id="f3" v-model="route.catalog">
            <option :value="null">-</option>
            <option v-for="item in categories" track-by="$index" :value="item">{{item}}</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label for="f3" class="col-xs-3 control-label">是否青春路线</label>
        <div class="col-xs-9">
          <label class="radio-inline">
            <input type="radio" v-model="route.isYouth" :value="1" /> 是
          </label>
          <label class="radio-inline">
            <input type="radio" v-model="route.isYouth" :value="0" /> 否
          </label>
        </div>
      </div>

      <div class="form-group">
        <label class="col-xs-3 control-label">城区</label>
        <div class="col-xs-4">
          <select class="form-control" v-model="route.city" change="route.cityBlock = null">
            <option :value="null">-</option>
            <option :value="city.name" v-for="city in areas">{{city.name}}</option>
          </select>
        </div>
        <div class="col-xs-4">
          <select class="form-control" v-model="route.cityBlock">
            <option :value="null">-</option>
            <option :value="item" v-for="item in cityBlockList">{{item}}</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label for="f2" class="col-xs-3 control-label">主题</label>
        <div class="col-xs-9">
          <label class="checkbox-inline" v-for="item in theme" track-by="$index">
            <input type="checkbox" v-model="route.termIds" :value="item.id"> {{item.title}}
          </label>
        </div>
      </div>
      <div class="from-group">
        <div class="col-xs-9 col-xs-offset-3">
          <button class="btn btn-primary" type="button" @click="click(create)($event, route)">创建</button>
        </div>
      </div>
    </form>
  </aside>
</template>

<script>
  import { aside } from 'vue-strap'
  import api from '../../libs/api'
  import config from '../../libs/config'
  import utils from '../../libs/utils'

  let route = {
    abbreviation: '',
    heading: '',
    catalog: null,
    city: null,
    isYouth: 0,
    termIds: [],
    cityBlock: null
  }

  export default {
    components: {
      aside
    },
    props: {
      show: {
        required: true,
        twoWay: true
      }
    },
    data () {
      return {
        route: Object.assign({}, route),
        areas: config.areas.slice(),
        categories: config.categories.slice(),
        cityBlockList: [],
        theme: []
      }
    },
    computed: {
      cityBlockList () {
        if (this.route.city) {
          this.route.cityBlock = null
          let selectCity = this.areas.filter(({name}) => name === this.route.city)[0]
          if (selectCity) {
            return selectCity.sub
          } else {
            return []
          }
        } else {
          return []
        }
      }
    },
    watch: {
      show (val) {
        if (val) {
          this.getTags()
        }
      }
    },
    methods: {
      getTags () {
        return api.tag.getTags()
          .then(({theme}) => {
            this.$set('theme', theme)
          })
      },
      create (route) {
        return this.$http.post(config.apiWe + '/product/route', route)
          .then(({data}) => {
            this.show = false
            setTimeout(() => {
              this.$route.router.go(`/route/${data}/basic`)
            })
          })
      },
      click: utils.click
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** CreateRoute.vue?35520ed4
 **/